import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PermitDetail } from '../../../models/permit-detail.model';
import { isViewableImage, uploadedDocumentUrl } from '../uploaded-document-url';

/** Recreation detail - common fields plus the site's vehicle/people counts and boat photo. */
@Component({
    selector: 'app-recreation-detail',
    templateUrl: './recreation-detail.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class RecreationDetailComponent {
    @Input() permit!: PermitDetail;

    /** Served through the backend, not straight off the bucket - see the helper. */
    public readonly documentUrl = uploadedDocumentUrl;
    /** Photos render inline; anything else stays a link. */
    public readonly isImage = isViewableImage;
}
